import React, { useEffect, useState, useRef, useReducer } from 'react';
import { container } from 'tsyringe';
import { ApiService } from '../../services/api-service';
import { PTApiService } from '../../services/ptapi-service';
import { SoundKey, SoundService } from '../../services/sound-service';
import { Event } from '../../models/channelClass';
import './GoLive.scss'
import { useSharedState } from '../../utils/helpers';
import DestinationPanel from './liveStatus/DestinationPanel';

import Lottie from 'react-lottie-player'
import lottieSpinnerJson from '../../assets/lottie/loading_spinner.json';
import { LAYOUT_SET_LIVESTREAM_RUNNING } from '../../redux/layout/layoutReducer';
import { useDispatch, useSelector } from 'react-redux';
import LiveExitDialog from './liveStatus/LiveExitDialog';
import { ErrorService } from '../../services/error-service';
import RegisterPopup from './RegisterPopup';


const GoLive = () => {

  const [ptApiService] = useState(container.resolve(PTApiService));
  const [apiService] = useState(container.resolve(ApiService));
  const [soundService] = useState(container.resolve(SoundService));
  const [errorService] = useState(container.resolve(ErrorService));

  const outputStreams = useSelector((state: any) => state.layout.outputStreams);

  const [countInterval, setCountInterval] = useState(undefined);
  let numberOfSecondsForCountDown = 10;


  const tips = [
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 0",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 1",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 2",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 3",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 4",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 5",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 6",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 7",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 8",
    "🎩✨ Pro Tip: Put pro tip text here that can change throughout the countdown. 9",
  ];

  const [isCountDownRunning, setIsCountDownRunning] = useState(false);
  const [isStreamStarted, setIsStreamStarted] = useState(false);
  const [isEndStreamDialogVisible, setEndStreamDialogVisible] = useState(false);

  const dispatchRedux = useDispatch();

  let [event] = useSharedState(apiService.event$);

  const reducer = (count, action) => {
    switch (action.type) {
      case "Decrement":
        console.log('GOLIVE: decrement count=', count);
        if (count === 1) {
          if (isCountDownRunning) {
            clearInterval(countInterval);
            setIsCountDownRunning(false);

            setIsStreamStarted(true);
          }
          return numberOfSecondsForCountDown;
        } else {
          return count - 1;
        }
      case "Reset":
        console.log('GOLIVE: reset count=', count);
        clearInterval(countInterval);
        setIsCountDownRunning(false);
        return numberOfSecondsForCountDown;

      default:
        return count;
    }
  }
  const [count, dispatch] = useReducer(reducer, numberOfSecondsForCountDown);

  const [isGoLiveOpened, setIsGoliveOpen] = useState(false);


  const goliveOpen = (e, open) => {
    //DEMO
    apiService.toggleRegisterPopup();

    // console.log('goliveopen');
    // if (e) e.stopPropagation();
    // setIsGoliveOpen(open);
    // if (!open) {
    //   stopStream(null);
    // }
  }

  useEffect(() => {
    console.log('Received Event', event);
    if (event.uuid) {
      if (event.status === 'LIVE') {
        if (!isCountDownRunning) {
          setIsStreamStarted(true);
        }
      } else {
        setIsStreamStarted(false);
      }
    }
  }, [event]);

  useEffect(() => {
    dispatchRedux({ type: LAYOUT_SET_LIVESTREAM_RUNNING, payload: isStreamStarted });
  }, [isStreamStarted])

  const stopStream = (e) => {
    if (e) e.stopPropagation();
    if (isStreamStarted) {
      // open EndStream dialog confirmation
      setEndStreamDialogVisible(true);
      soundService.playSoundStart(SoundKey.Popup);
    } else {
      // nothing to do ->  to be confirmed TODO
    }
  }

  const closeExit = async (value) => {
    setEndStreamDialogVisible(false);
    if (value === 'cancel') {
      console.log('EXIT canceled');
    } else {
      console.log('EXIT confirmed');
      dispatch({ type: 'Reset' });
      setIsCountDownRunning(false);
      try {
        // await apiService.stopLive();
        // await ptApiService.stopBroadcast();
      } catch (e) {
        console.error(e);
        errorService.throwError({
          code: 'END_LIVE_ERROR',
          message: e?.message || e,
          type: 'unknown'
        });
      } finally {
        setIsStreamStarted(false);
        soundService.playSoundStart(SoundKey.EndStream);
      }
    }
  }

  const startCountDown = async (e) => {

    if (e) e.stopPropagation();

    // setIsGoliveOpen(false);

    // console.log("GOLIVE: START COUNT DOWN")
    // setIsCountDownRunning(true);
    // clearInterval(countInterval);
    // setCountInterval(setInterval(_ => {
    //   dispatch({ type: 'Decrement' });
    // }, 1000) as any);

    // // send GOLIVE now to the backend server to start all streams
    // console.log('GOLIVE: call api');
    // // try {
    // //   await apiService.goLive(outputStreams);
    // // } catch (e) {
    // //   console.error(e);
    // //   errorService.throwError({
    // //     code: 'SS_GOLIVE_ERROR',
    // //     message: e?.message || e,
    // //     type: 'unknown'
    // //   });
    // //   setIsStreamStarted(false);
    // //   setIsCountDownRunning(false);
    // //   return;
    // // }

    // // try {
    // //   await ptApiService.startBroadcast();
    // // } catch (e) {
    // //   console.error(e);
    // //   // If goLive failed on PT api, then stop live on SS
    // //   await apiService.stopLive();
    // //   errorService.throwError({
    // //     code: 'PT_GOLIVE_ERROR',
    // //     message: 'An error occurred while trying to launch live',
    // //     type: 'unknown'
    // //   });
    // //   setIsStreamStarted(false);
    // //   setIsCountDownRunning(false);
    // //   return;
    // // }

    soundService.playSoundStart(SoundKey.GoLive);
  }

  // demoC   replace GOLIVE by   Try / Buy
  return (
    <>
      {!isStreamStarted &&

      <button id="goliveREF" className="studio-primary-btn golive-btn" onClick={(e) => goliveOpen(e, true)}>Try / Buy</button>


        // <div id="goliveREF" className="golive-button" onClick={(e) => goliveOpen(e, true)}>
        //   {!isCountDownRunning ?
        //     "GO LIVE" :
        //     <Lottie loop animationData={lottieSpinnerJson} play style={{ width: "100%", height: "100%", color: "white" }} />
        //   }
        //   {!isCountDownRunning && isGoLiveOpened &&
        //     <div className="golive-background">
        //       <div className="golive-destination">
        //         <div className="golive-intro">Ready to go live?</div>
        //         <DestinationPanel isGoingLive={true}></DestinationPanel>
        //         <div className="golive-footer">
        //           <div className="golive-button-discard" onClick={(e) => goliveOpen(e, false)}>
        //             NOT YET
        //           </div>
        //           <div className="golive-button-go golive-button" onClick={(e) => startCountDown(e)}>
        //             GO LIVE
        //           </div>

        //         </div>
        //       </div>
        //     </div>
        //   }
        // </div>

      }

      {!isStreamStarted && isCountDownRunning &&
        <div className="golive-background">

          <div className="countdown">
            <div className="main-text">
              Your event is starting in...
            </div>
            <div className="countdown-numbers-upper">
              <div className="countdown-numbers-lower">
                {count}
              </div>
            </div>
            <div className="protips">{tips[count % tips.length]}</div>
          </div>
        </div>
      }

      {isStreamStarted &&
        <div className="end-stream-button" onClick={(e) => stopStream(e)}>
          END STREAM
        </div>
      }

      <LiveExitDialog open={isEndStreamDialogVisible} onClose={(e) => closeExit(e)}></LiveExitDialog>
    </>


  );
}

export default GoLive;